import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

interface BackButtonProps {
  fallback: string;
  children?: React.ReactNode;
  className?: string;
  type?: 'button' | 'submit';
  modeSwitch?: boolean;
}

/**
 * In-App-Zurück. Nutzt die Browser-Historie, wenn es einen vorherigen Eintrag gibt,
 * sonst `fallback` (z.B. direkte URL / Reload).
 */
export function BackButton({
  fallback,
  children = '← Zurück',
  className,
  type = 'button',
  modeSwitch = false,
}: BackButtonProps) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = () => {
    if (location.key !== 'default') {
      navigate(-1);
    } else {
      navigate(fallback);
    }
  };

  return (
    <button type={type} className={className} data-gamepad-mode={modeSwitch ? '' : undefined} onClick={handleClick}>
      {children}
    </button>
  );
}
